export default {
  name: 'transaction_informations_message',
  component_path: 'modules/procedures/blocks/informations/BlockMessage'
}